import 'bootstrap/js/collapse';
import 'bootstrap/js/transition';
import './map';
import './scrollTo';
import './gallery';
import './scrollReveal';
import './mobileMenu';



//////////////////
// WEBPACK FOOTER
// ./assets/js/main.js
// module id = 4
// module chunks = 0